export default __webpack_public_path__ + "static/media/news178.45142fcb.jpg";